import { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PenLine } from "lucide-react";
import SectionHeading from "../components/ui/SectionHeading";
import BlogCard from "../components/blog/BlogCard";
import BlogFilters from "../components/blog/BlogFilters";
import { getBlogPosts, getCategories } from "../content/blog";

const Blog = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const categories = getCategories();
  const posts = useMemo(() => getBlogPosts(activeCategory), [activeCategory]);

  return (
    <section
      id="blog"
      className="pt-4 pb-10 px-4 sm:px-6 md:px-16 bg-white dark:bg-gray-900 transition-colors duration-300"
    >
      <div className="container mx-auto max-w-screen-xl">
        <SectionHeading
          title="Blog"
          subtitle="Thoughts, tutorials & experiences in test automation"
          gradient="violet"
        />

        {/* Filters */}
        <BlogFilters
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        {/* Post Grid */}
        {posts.length > 0 ? (
          <AnimatePresence mode="wait">
            <motion.div
              key={activeCategory}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
            >
              {posts.map((post, index) => (
                <BlogCard
                  key={post.slug}
                  post={post}
                  index={index}
                />
              ))}
            </motion.div>
          </AnimatePresence>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center py-16"
          >
            <PenLine
              size={48}
              className="mx-auto text-gray-300 dark:text-gray-600 mb-4"
            />
            <p className="text-gray-500 dark:text-gray-400 text-lg">
              No posts in this category yet.
            </p>
            <button
              onClick={() => setActiveCategory("All")}
              className="mt-3 text-blue-600 dark:text-blue-400 hover:underline text-sm font-medium"
            >
              View all posts
            </button>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default Blog;
